import { render, staticRenderFns } from "./PurchaseOrderAttachedFilesDrawer.vue?vue&type=template&id=1087fcc5&scoped=true"
import script from "./PurchaseOrderAttachedFilesDrawer.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderAttachedFilesDrawer.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderAttachedFilesDrawer.vue?vue&type=style&index=0&id=1087fcc5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1087fcc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1087fcc5')) {
      api.createRecord('1087fcc5', component.options)
    } else {
      api.reload('1087fcc5', component.options)
    }
    module.hot.accept("./PurchaseOrderAttachedFilesDrawer.vue?vue&type=template&id=1087fcc5&scoped=true", function () {
      api.rerender('1087fcc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchase-orders/PurchaseOrderAttachedFilesDrawer.vue"
export default component.exports